import App from '../TicTacBot/TicTacBot'

export default App;